webpackJsonp([12236887540491],{

/***/ 445:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>This is a test for the If This Then That service for my Blog feed.</p>","frontmatter":{"categories":["General Updates"],"date":"May 26, 2017","featuredImage":"placeholder.png","title":"Xbox One Elite Controller Review"}}},"pathContext":{"slug":"/twitter-ifttt-test/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---post-twitter-ifttt-test-28535ed605a019a2da83.js